import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OrganizationsComponent } from './views/organizations/organizations.component';
import { HouseholdsComponent } from './views/households/households.component';
import { UsersRoutingModule } from './users-routing.module';
import { FilesModule } from '../files/files.module';
import { MyAccountComponent } from './views/my-account/my-account.component';
import { UsersSubnavComponent } from './components/users-subnav/users-subnav.component';
import { SharedModule } from '../shared/shared.module';
import { NewUserComponent } from './components/new-user/new-user.component';
import { UserDetailComponent } from './views/user-detail/user-detail.component';
import { UserDetailGeneralComponent } from './components/user-detail-general/user-detail-general.component';
import { UserDetailFilesComponent } from './components/user-detail-files/user-detail-files.component';
import { UserDetailAccessComponent } from './components/user-detail-access/user-detail-access.component';
import { UserDetailActivityComponent } from './components/user-detail-activity/user-detail-activity.component';
import { UserDetailHouseholdsComponent } from './components/user-detail-households/user-detail-households.component';
import { SystemAdminComponent } from './views/system-admin/system-admin.component';
import { AuditTrailAdminComponent } from './views/system-admin/audit-trail-admin/audit-trail-admin.component';
import { AiUsageAdminComponent } from './views/system-admin/ai-usage-admin/ai-usage-admin.component';

@NgModule({
  declarations: [
    OrganizationsComponent,
    SystemAdminComponent,
    AuditTrailAdminComponent,
    AiUsageAdminComponent,
    HouseholdsComponent,
    MyAccountComponent,
    UsersSubnavComponent,
    NewUserComponent,
    UserDetailComponent,
    UserDetailGeneralComponent,
    UserDetailFilesComponent,
    UserDetailAccessComponent,
    UserDetailActivityComponent,
    UserDetailHouseholdsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UsersRoutingModule,
    SharedModule,
    FilesModule
  ],
  exports: [
    NewUserComponent
  ]
})
export class UsersModule { }
